import {
  GET_COMPANIES,
  GET_COMPANIES_SUCCEED,
  GET_COMPANIES_FAILED,
  GET_COMPANY_DETAILS,
  GET_COMPANY_DETAILS_SUCCEED,
  GET_COMPANY_DETAILS_FAILED,
  REMOVE_COMPANY_INFO,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCEED,
  GET_COUNTRIES_FAILED,
  CRM_GET_STAFF,
  CRM_GET_STAFF_SUCCEED,
  CRM_GET_STAFF_FAILED,
  CRM_UPDATE_SELECTED_COMPANY,
  CRM_UPDATE_SELECTED_COMPANY_SUCCEED,
  CRM_UPDATE_SELECTED_COMPANY_FAILED,
  CREATE_PAYMENT_INFO,
  CREATE_PAYMENT_INFO_SUCCEED,
  CREATE_PAYMENT_INFO_FAILED,
  GET_CRM_CATEGORIES,
  GET_CRM_CATEGORIES_SUCCEED,
  GET_CRM_CATEGORIES_FAILED,
  GET_CRM_COUNTRY_DATASET,
  GET_CRM_COUNTRY_DATASET_SUCCEED,
  GET_CRM_COUNTRY_DATASET_FAILED,
  CREATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_SUCCEED,
  CREATE_SUBSCRIPTION_FAILED,
  CRM_INVITE_USER,
  CRM_INVITE_USER_SUCCEED,
  CRM_INVITE_USER_FAILED,
  CRM_REMOVE_USER,
  CRM_REMOVE_COMPANY,
  CRM_REMOVE_COMPANY_SUCCEED,
  CRM_REMOVE_COMPANY_FAILED,
  GET_AUDIENCE_ACTIVITY,
  GET_AUDIENCE_ACTIVITY_SUCCEED,
  GET_AUDIENCE_ACTIVITY_FAILED,
  RESET_ERRORS_AUDIENCE_ACTIVITY
} from "../../constants";

export const getCompanies = () => ({
  type: GET_COMPANIES
});

export const getCompaniesSucceed = companies => ({
  type: GET_COMPANIES_SUCCEED,
  payload: companies
});

export const getCompaniesFailed = errors => ({
  type: GET_COMPANIES_FAILED,
  payload: errors
});

export const getCompany = () => ({
  type: GET_COMPANY_DETAILS
});

export const getCompanySucceed = company => ({
  type: GET_COMPANY_DETAILS_SUCCEED,
  payload: company
});

export const getCompanyFailed = errors => ({
  type: GET_COMPANY_DETAILS_FAILED,
  payload: errors
});

export const removeCompanyInfo = () => ({
  type: REMOVE_COMPANY_INFO
});

export const getCountries = () => ({
  type: GET_COUNTRIES
});

export const getCountriesSucceed = countries => ({
  type: GET_COUNTRIES_SUCCEED,
  payload: countries
});

export const getCountriesFailed = errors => ({
  type: GET_COUNTRIES_FAILED,
  payload: errors
});

export const getStaff = () => ({
  type: CRM_GET_STAFF
});

export const getStaffSucceed = staff => ({
  type: CRM_GET_STAFF_SUCCEED,
  payload: staff
});

export const getStaffFailed = errors => ({
  type: CRM_GET_STAFF_FAILED,
  payload: errors
});

export const updateSelectedCompany = () => ({
  type: CRM_UPDATE_SELECTED_COMPANY
});

export const updateSelectedCompanySucceed = company => ({
  type: CRM_UPDATE_SELECTED_COMPANY_SUCCEED,
  payload: company
});

export const updateSelectedCompanyFailed = errors => ({
  type: CRM_UPDATE_SELECTED_COMPANY_FAILED,
  payload: errors
});

export const resetErrorsAudienceActivity = () => ({
  type: RESET_ERRORS_AUDIENCE_ACTIVITY
});

export const getAudienceActivity = () => ({
  type: GET_AUDIENCE_ACTIVITY
});

export const getAudienceActivitySucceed = info => ({
  type: GET_AUDIENCE_ACTIVITY_SUCCEED,
  payload: info
});

export const getAudienceActivityFailed = errors => ({
  type: GET_AUDIENCE_ACTIVITY_FAILED,
  payload: errors
});

export const createPaymentInfo = () => ({
  type: CREATE_PAYMENT_INFO
});

export const createPaymentInfoSucceed = paymentInfo => ({
  type: CREATE_PAYMENT_INFO_SUCCEED,
  payload: paymentInfo
});

export const createPaymentInfoFailed = errors => ({
  type: CREATE_PAYMENT_INFO_FAILED,
  payload: errors
});

export const getCategories = () => ({
  type: GET_CRM_CATEGORIES
});

export const getCategoriesSucceed = categories => ({
  type: GET_CRM_CATEGORIES_SUCCEED,
  payload: categories
});

export const getCategoriesFailed = errors => ({
  type: GET_CRM_CATEGORIES_FAILED,
  payload: errors
});

export const getCountryDatasets = () => ({
  type: GET_CRM_COUNTRY_DATASET
});

export const getCountryDatasetsSucceed = dataset => ({
  type: GET_CRM_COUNTRY_DATASET_SUCCEED,
  payload: dataset
});

export const getCountryDatasetsFailed = errors => ({
  type: GET_CRM_COUNTRY_DATASET_FAILED,
  payload: errors
});

export const createSubscription = () => ({
  type: CREATE_SUBSCRIPTION
});

export const createSubscriptionSucceed = subscription => ({
  type: CREATE_SUBSCRIPTION_SUCCEED,
  payload: subscription
});

export const createSubscriptionFailed = errors => ({
  type: CREATE_SUBSCRIPTION_FAILED,
  payload: errors
});

export const inviteCompanyUser = () => ({
  type: CRM_INVITE_USER
});

export const inviteCompanyUserSucceed = user => ({
  type: CRM_INVITE_USER_SUCCEED,
  payload: user
});

export const inviteCompanyUserFailed = errors => ({
  type: CRM_INVITE_USER_FAILED,
  payload: {
    email: errors
  }
});

export const removeCompanyUser = id => ({
  type: CRM_REMOVE_USER,
  payload: id
});

export const removeCompany = () => ({
  type: CRM_REMOVE_COMPANY
});

export const removeCompanySucceed = id => ({
  type: CRM_REMOVE_COMPANY_SUCCEED,
  payload: id
});

export const removeCompanyFailed = errors => ({
  type: CRM_REMOVE_COMPANY_FAILED,
  payload: errors
});
